/** these are the clients of the customers. These can be assigned to technicians and will have
 * a number of sites
 */


export default {
    name: 'client',
    title: 'Cliente',
    type: 'document',
    fields: [
      {
        name: 'label',
        title: 'Nome',
        type: 'string',
        validation: Rule => Rule.required()
      },

      {
        name: 'tenderDiscount',
        title: 'Sconto',
        type: 'number',
/*         validation: (Rule) => Rule.positive(),
        options: {
          decimalScale: 0,
          fixedDecimalScale: true,
          allowNegative: false,
          suffix: ' %',
        }, */
      }, 
      {
        name: 'revision',
        title: 'Revisione',
        type: 'boolean'
    },
    {
      name: 'maintenanceTasksIncluded',
      title: 'RevisioniIncluse',
      type: 'array',
      of: [
          {   
            type: 'reference',
            to: [{ type: 'registerTemplates' }],
          }
      ],
  },  
      {
      name: 'customerProductsIncludedInTender',
      title: "Prodotti Inclusi nell'appalto",
      type: 'array',
      of: [
          {   
            type: 'reference',
            to: [{ type: 'customerProduct' }],
          }
      ],
  }, 
    {
      name: 'notComune',
      title: 'NoComuneDi',
      type: 'boolean'
  },     
      {
      name: 'customer',
        title: 'Customer',
        type: 'reference',
        validation: Rule => Rule.required(),
        to: [{ type: 'customer' }],
        
      },
      {
          name: 'clientTemplate',
          title: 'ClienteTemplate',
          type: 'boolean'
      }, 
      {
        name: 'contractors',
        title: 'Subappaltatori',
        type: 'array',
        of: [
            {   
              type: 'reference',
              to: [{ type: 'customer' }],
            }
        ],
    },
    {
      name: 'offers',
      title: 'Offerte',
      type: 'array',
      of: [
          {   
            type: 'offer',
          }
      ],
  },
    {
      name: 'facility',
      title: 'Facility',
      type: 'boolean'
  },
      {
        name: 'priceLists',
        title: 'Listini',
        type: 'array',
        of: [
            {   
              type: 'reference',
              to: [{ type: 'priceList' }],
            }
        ],
    },

      {
        name: 'Cd_CF',
        title: 'ArcaId',
        type: 'string',
      },
      {
        name: 'houseNumber',
        title: 'NumeroCivico',
        type: 'string'
    },
    {
        name: 'address1',
        title: 'Indirizzo1',
        type: 'string'
    },
    {
        name: 'address2',
        title: 'Indirizzo2',
        type: 'string'
    },
    {
        name: 'city',
        title: 'città',
        type: 'string'
    },
    {
        name: 'province',
        title: 'Provincia',
        type: 'string'
    },

    {
        name: 'postCode',
        title: 'CAP',
        type: 'string'
    },
    {
      name: 'pec',
      title: 'Pec',
      type: 'email'
  },
    {
      name: 'status',
      title: 'Status',
      type: 'string',
    },
    {
      name: 'emailComms',
      title: 'EmailRicevute',
      type: 'array',
      of: [
          {   
            type: 'userEmail',
          }
      ],
    },
    {
      name: 'notes',
      title: 'Note',
      type: 'richTextObject',
    },

    ]
}